const educationData = [
  {
    degree: "Full Stack Development ( MERN )",
    university: " private limited IIT",
    date: "Jan 2021 - Aug 2022",
    // score:"",
    points: [
      "I've learned full stack development technologies, such as HTML, CSS, Javascript, React.js, Bootstrap, Node.js, MySQL, Mongodb, DS, and algorithms.",
      "In addition, I have done real-world projects using MERN technology."
    ]
  },
  {
    degree: "economic ",
    university: "University of damascus, syria",
    date: "2011 - 2015",
  //  score:"80%",
    points:["I have studied accounting, economics, statistics, taxation, and other basic business disciplines."]
  },
  // {
  //   degree: "Chartered Accountancy - CPT",
  //   university: "Instiute of Chartered Accountants of India (ICAI)",
  //   date: "2016 - 2021",
  //   score:"72%",
  //   points:["I learned business law, accountancy, economics, and mathematics.", "I passed with distinction on my first try."]
  // },
]

export default educationData;